module.exports = __webpack_public_path__ + "static/media/CargoCombinedVertLogo.ac206398.png";